import BlogPostAdapter from '@/features/blog/requests/adapters/blog-post-adapter';
import { type BlogPostResponse } from '@/features/blog/types/blog-post-response-types';
import { type BlogPost } from '@/features/blog/types/blog-post-types';
import placeNameToUrl from '@/features/place/utils/place-name-to-url';
import randomInteger from '@/shared/utils/random-integer';

export default async function getRandomBlogPost(location: string): Promise<BlogPost> {
  const blogUrl = 'https://roomster.com/blog';
  const locationParts = location.split(', ');
  const getBlogUrl = (hash:string, limit: string) => `${blogUrl}/ghost/api/content/posts/?limit=${limit}&filter=tag%3A${hash}&key=49cd97a9f5d6d9c6ec0a5e0157`;

  let geoHash = '-hash-geo';

  // eslint-disable-next-line no-restricted-syntax
  for (const locationPart of locationParts) {
    let escapedHash = locationPart.replaceAll(/['*]/g, '-');
    escapedHash = locationPart.replaceAll('.', '');
    const preparedHash = placeNameToUrl(escapedHash);

    // eslint-disable-next-line no-await-in-loop
    const response = await fetch(getBlogUrl(preparedHash, '1'), { cache: 'no-store' });
    // eslint-disable-next-line no-await-in-loop
    const data = await response.json() as { posts: BlogPostResponse[] };

    if (data.posts.length > 0) {
      geoHash = preparedHash;
      break;
    }
  }

  const postsResponse = await fetch(getBlogUrl(geoHash, '15'));
  const postsData = await postsResponse.json() as { posts: BlogPostResponse[] };
  const blogPosts = postsData.posts.map((post) => BlogPostAdapter(post));

  const randomPostNumber = randomInteger(0, blogPosts.length - 1);

  return blogPosts[randomPostNumber];
}
